"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class RecordingClientV4 extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.baseUrl = '/v4/projects/';
    }
    getSessions(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getSessionsCount(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/count`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPagesForSession(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId, visitorId, sessionNumber } = request, body = __rest(request, ["projectId", "visitorId", "sessionNumber"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/${visitorId}/sessions/${sessionNumber}/pages`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPages(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/pages`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPagesCount(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/pages/count`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getVisitors(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getVisitorsCount(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/count`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getTriggeredEventsForVisitors(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/visitors/events`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getTriggeredEventsForSessions(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/sessions/events`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getTriggeredEventsForPages(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/pages/events`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getPlayingToken(projectId, visitorId, sessionNumber, pageNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/session-replay/playingToken?${this.getQueryString({
                visitorId,
                sessionNumber,
                pageNumber,
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getFreshRecordingsFromVertica(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const { projectId } = request, body = __rest(request, ["projectId"]);
            const url = `${this.baseUrl}${projectId}/session-replay/fresh-recordings`;
            const response = yield this.httpPost(url, body);
            return response.payload;
        });
    }
    getClicktalePlayingToken(projectId, visitorId, sessionNumber, pageNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/session-replay/playingToken?${this.getQueryString({
                visitorId,
                sessionNumber,
                pageNumber,
                type: 'clicktale',
            })}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getClicktaleXStudioToken(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.baseUrl}${projectId}/session-replay/xstudioToken`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.RecordingClientV4 = RecordingClientV4;
//# sourceMappingURL=recording.client.v4.js.map